import { render } from "./AddPayrollEmployeeConfig.vue?vue&type=template&id=70822280&scoped=true"
import script from "./AddPayrollEmployeeConfig.vue?vue&type=script&lang=js"
export * from "./AddPayrollEmployeeConfig.vue?vue&type=script&lang=js"

import "./AddPayrollEmployeeConfig.vue?vue&type=style&index=0&id=70822280&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70822280"]])

export default __exports__